// Relative Api Paths
const RelativePath = "api/v1";

const URI = {
  LOGIN: `${RelativePath}/login`,
};

export { URI };
